module.exports = __webpack_public_path__ + "static/app_process-19438135c7ad4469a256810f87748ead.png";